// utils/deviceConfig.js

/**
 * features -> Funcionalidades a serem exibidas
 * trending -> Dados dos últimos 3 meses em disponibilidade
 * metaData -> Metadados como label de campos
 */
const deviceConfig = {
  /**
   * Configuração para o dispositivo Mikrotik
   */
  mikrotik: {
    features: {
      cardStatusPing: true,
      firmwareVersion: true,
      supplyVoltage: true,
    },
    metaData: {
      ifLabel: "Interface",
    },
  },
  /**
   * Configuração para o dispositivo Datacom
   */
  datacom: {
    features: {
      opticalTransceiver: true,
    },
    metaData: {
      ifLabel: "Sfp",
    },
  },
  /**
   * Configuração comum para ONU's
   */
  onu: {
    metaData: {
      ifLabel: "ONU",
    },
  },
  /**
   * Configuração para dispositivos BGP (Huawei/Nokia routers)
   */
  bgp: {
    metaData: {
      ifLabel: "Interface",
    },
  },
  /**
   * Configuração para dispositivos ICMP
   */
  icmp: {
    metaData: {
      ifLabel: "Host",
    },
  },
};

/**
 * Lista de dispositivos válidos para referência
 */
const AVAILABLE_DEVICES = [
  "SWITCHES CISCO C3XXX",
  "SWITCHES MIKROTIK",
  "SWITCHES DATACOM",
  "SWITCHES HUAWEI",
  "OLT FIBERHOME",
  "OLT HUAWEI",
  "OLT ZTE",
  "OLT NOKIA",
  "OLT DATACOM",
  "OLT PHYHOME",
  "ICMP PADRAO",
  "ICMP CAMERA",
  "RADIOS UBIQUITI",
  "RADIOS MIKROTIK",
  "ROTEADORES HUAWEI",
  "ROTEADORES NOKIA",
];

/**
 * Função principal que mapeia grupos para o deviceType correto
 * @param {Array} groups - Array de objetos { name: string }
 * @returns {string} - deviceType: "mikrotik" | "datacom" | "onu" | "bgp" | "icmp" | "unknown"
 */
function getDeviceType(groups) {
  // Verifica se os grupos são um array
  if (!Array.isArray(groups)) {
    return "unknown";
  }

  const onuList = [
    "olt fiberhome",
    "olt datacom",
    "olt huawei",
    "olt zte",
    "olt nokia",
    "olt phyhome",
  ];

  // Itera sobre os grupos
  for (let group of groups) {
    if (!group?.name) continue;

    const name = group?.name?.toLowerCase();

    switch (true) {
      // ONUs: qualquer OLT da lista
      case onuList?.some((item) => name?.includes(item)):
        return "onu";

      // Mikrotik: switches mikrotik, radios mikrotik, radios ubiquiti, switches cisco
      case name?.includes("switches mikrotik") ||
        name?.includes("radios mikrotik") ||
        name?.includes("radios ubiquiti") ||
        name?.includes("switches cisco"):
        return "mikrotik";

      // Datacom: switches datacom
      case name?.includes("switches datacom"):
        return "datacom";

      // BGP: switches huawei, roteadores huawei, roteadores nokia
      case name?.includes("switches huawei") ||
        name?.includes("roteadores huawei") ||
        name?.includes("roteadores nokia"):
        return "bgp";

      // ICMP: qualquer grupo com "icmp" no nome
      case name?.includes("icmp"):
        return "icmp";

      default:
        // Continua a checagem até encontrar uma correspondência
        continue;
    }
  }

  // Se o loop terminar sem encontrar uma correspondência, retorna "unknown"
  return "unknown";
}

/**
 * Função auxiliar para obter a configuração completa do dispositivo
 * @param {string} deviceType - Tipo do dispositivo retornado por getDeviceType
 * @returns {Object} - Configuração com features e metaData
 */
function getDeviceConfig(deviceType) {
  const config = deviceConfig?.[deviceType] || {};

  // Fallback com configuração padrão
  return {
    features: {
      ...(deviceConfig?.default?.features || {}),
      ...(config?.features || {}),
    },
    metaData: {
      ...(deviceConfig?.default?.metaData || {}),
      ...(config?.metaData || {}),
    },
  };
}

module.exports = {
  AVAILABLE_DEVICES,
  getDeviceType,
  getDeviceConfig,
};
